import { equals } from "@tm/utils"

export function getCommonItems<T>(array1: T[], array2: T[], comparator?: (item1: T, item2: T) => boolean | undefined) {
    return array1.filter((item1) => array2.find((item2) => comparator?.(item1, item2) ?? equals(item1, item2)))
}
